<div class="flex flex-column gap-2" [formGroup]="form">
  <app-input-number name="previsioneAbitantiServiti" [integer]="true"  label="Abitanti serviti" [form]="form"></app-input-number>
  <app-input-number name="previsionePortata" [step]="0.001"  label="Portata" [form]="form"></app-input-number>
  <app-input-text name="descrizionePunto" label="Descrizione" [form]="form"></app-input-text>
  <app-input-text name="note" label="Note" [form]="form"></app-input-text>
</div>
